:host {
	max-width: 50ch;
}
